// extracted by mini-css-extract-plugin
export default {"rateForm":"CurrentRateAdmin_rateForm__OZQTf","rate":"CurrentRateAdmin_rate__YE1fq"};